import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import {
  MessageSquare, CheckSquare, Bell, Settings,
  FileText, LogOut, Zap
} from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { useNotifStore } from '../store/notifStore';
import styles from './Layout.module.css';

const NAV = [
  { to: '/chat',          icon: MessageSquare, label: 'Chat' },
  { to: '/tasks',         icon: CheckSquare,   label: 'Task' },
  { to: '/notifications', icon: Bell,          label: 'Alert' },
  { to: '/logs',          icon: FileText,      label: 'Log' },
  { to: '/settings',      icon: Settings,      label: 'Setup' },
];

export default function Layout() {
  const logout = useAuthStore(s => s.logout);
  const unread = useNotifStore(s => s.unread);
  const navigate = useNavigate();

  return (
    <div className={styles.shell}>
      {/* Sidebar */}
      <aside className={styles.sidebar}>
        <div className={styles.logo}>
          <Zap size={20} />
          <span>JARVIS</span>
        </div>

        <nav className={styles.nav}>
          {NAV.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.active : ''}`
              }
            >
              <div className={styles.iconWrap}>
                <Icon size={18} />
                {to === '/notifications' && unread > 0 && (
                  <span className={styles.badge}>{unread > 9 ? '9+' : unread}</span>
                )}
              </div>
              <span className={styles.navLabel}>{label}</span>
            </NavLink>
          ))}
        </nav>

        <button
          className={styles.logoutBtn}
          onClick={() => { logout(); navigate('/'); }}
          title="Esci e torna al login"
        >
          <LogOut size={18} />
          <span className={styles.navLabel}>Esci</span>
        </button>
      </aside>

      {/* Main */}
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
